import { LoyaltyEventCode, LoyaltyPointType } from "Infrastructure/Api/Api";
import { Resources } from "Translations/Resources";
import CakeIcon from "@mui/icons-material/Cake";
import PaymentsIcon from "@mui/icons-material/Payments";
import LaunchIcon from "@mui/icons-material/Launch";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupsIcon from "@mui/icons-material/Groups";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ExploreIcon from "@mui/icons-material/Explore";
import PublicIcon from "@mui/icons-material/Public";
import FlightIcon from "@mui/icons-material/Flight";
import PeopleIcon from "@mui/icons-material/People";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import RepeatIcon from "@mui/icons-material/Repeat";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import HubIcon from "@mui/icons-material/Hub";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import HandshakeIcon from "@mui/icons-material/Handshake";
import type { ReactNode } from "react";

export const EVENT_TO_ICON: Record<LoyaltyEventCode, ReactNode> = {
  [LoyaltyEventCode.Anniversary]: <CakeIcon />,
  [LoyaltyEventCode.Payment]: <PaymentsIcon />,
  [LoyaltyEventCode.PaymentStreak3]: <PaymentsIcon />,
  [LoyaltyEventCode.PaymentStreak5]: <PaymentsIcon />,
  [LoyaltyEventCode.PaymentStreak10]: <PaymentsIcon />,
  [LoyaltyEventCode.PaymentStreak30]: <PaymentsIcon />,
  [LoyaltyEventCode.PaymentStreak180]: <PaymentsIcon />,
  [LoyaltyEventCode.HunterDailyAppOpen]: <LaunchIcon />,
  [LoyaltyEventCode.HunterDailyAppOpenStreak3]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.HunterDailyAppOpenStreak5]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.HunterDailyAppOpenStreak10]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.HunterDailyAppOpenStreak30]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.HunterDailyAppOpenStreak180]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.HunterDailyAppOpenStreak365]: <LocalFireDepartmentIcon />,
  // Valor — Hunter referrals
  [LoyaltyEventCode.HunterReferUser]: <PersonAddIcon />,
  [LoyaltyEventCode.HunterRefer10]: <GroupsIcon />,
  [LoyaltyEventCode.HunterRefer50]: <GroupsIcon />,
  [LoyaltyEventCode.HunterRefer100]: <GroupsIcon />,
  // Valor — Merchant onboarding
  [LoyaltyEventCode.HunterMerchantOnboarded]: <StorefrontIcon />,
  [LoyaltyEventCode.HunterMerchant1]: <TrackChangesIcon />,
  [LoyaltyEventCode.HunterMerchant10]: <TrackChangesIcon />,
  [LoyaltyEventCode.HunterMerchant50]: <TrackChangesIcon />,
  // Valor — Hunter recruitment
  [LoyaltyEventCode.HunterRecruitHunter]: <PersonSearchIcon />,
  [LoyaltyEventCode.HunterRecruit3]: <PersonSearchIcon />,
  [LoyaltyEventCode.HunterRecruit10]: <PersonSearchIcon />,
  // Valor — Merchant network
  [LoyaltyEventCode.HunterMerchantNetwork]: <HubIcon />,
  // Valor — Periodic merchant activity
  [LoyaltyEventCode.HunterWeeklyMerchant]: <CalendarTodayIcon />,
  [LoyaltyEventCode.HunterMonthlyMerchant]: <CalendarMonthIcon />,
  // Valor — Terminal placement
  [LoyaltyEventCode.HunterTerminalPlaced]: <PointOfSaleIcon />,
  [LoyaltyEventCode.HunterTerminalPlaced3]: <PointOfSaleIcon />,
  [LoyaltyEventCode.HunterTerminalPlaced10]: <PointOfSaleIcon />,
  [LoyaltyEventCode.HunterTerminalOfTheWeek]: <PointOfSaleIcon />,
  [LoyaltyEventCode.HunterTerminalOfTheMonth]: <PointOfSaleIcon />,
  // Valor — Hunter license closure
  [LoyaltyEventCode.HunterClosedHunter]: <HandshakeIcon />,
  // Stardust
  [LoyaltyEventCode.CustomerReferCustomer]: <PersonAddIcon />,
  [LoyaltyEventCode.CustomerReferCustomer10]: <GroupsIcon />,
  [LoyaltyEventCode.CustomerReferCustomer50]: <GroupsIcon />,
  [LoyaltyEventCode.CustomerReferCustomer100]: <GroupsIcon />,
  [LoyaltyEventCode.CustomerDailyAppOpen]: <LaunchIcon />,
  [LoyaltyEventCode.CustomerDailyAppOpenStreak3]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.CustomerDailyAppOpenStreak5]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.CustomerDailyAppOpenStreak10]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.CustomerDailyAppOpenStreak30]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.CustomerDailyAppOpenStreak180]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.CustomerDailyAppOpenStreak365]: <LocalFireDepartmentIcon />,
  [LoyaltyEventCode.CustomerCompleteRegistration]: <HowToRegIcon />,
  [LoyaltyEventCode.TenPayments]: <EmojiEventsIcon />,
  [LoyaltyEventCode.FiftyPayments]: <EmojiEventsIcon />,
  [LoyaltyEventCode.HundredPayments]: <EmojiEventsIcon />,
  [LoyaltyEventCode.ThousandPayments]: <EmojiEventsIcon />,
  [LoyaltyEventCode.Explorer]: <ExploreIcon />,
  [LoyaltyEventCode.Discoverer]: <PublicIcon />,
  [LoyaltyEventCode.Traveler]: <FlightIcon />,
  [LoyaltyEventCode.FriendPayment]: <PeopleIcon />,
  [LoyaltyEventCode.LargePayment]: <AttachMoneyIcon />,
  [LoyaltyEventCode.BankConnection]: <AccountBalanceWalletIcon />,
  [LoyaltyEventCode.FirstSpending]: <ShoppingCartIcon />,
  [LoyaltyEventCode.EngineIgnition]: <RocketLaunchIcon />,
  [LoyaltyEventCode.WeeklyMissionStart]: <CalendarTodayIcon />,
  [LoyaltyEventCode.RepeatedUsage]: <RepeatIcon />,
  [LoyaltyEventCode.MonthlyMissionStart]: <CalendarMonthIcon />,
};

export const POINTS_RESOURCES = {
  [LoyaltyPointType.Valor]: Resources.Pages.Content.Valor.PointsLabel.Points,
  [LoyaltyPointType.Stardust]:
    Resources.Pages.Content.Stardust.PointsLabel.Points,
};
